'use client';

import getSsoBaseUrl from './getSsoBaseUrl';

export default function getSsoProfileUrl() {
  const ssoBaseUrl = getSsoBaseUrl();
  const href = `${ssoBaseUrl}/profile`;
  return href;
}
